/**
 * Fragment for user profile data
 */
export const ProfileFragment = /* GraphQL */ `
  type
  username
  profileUrl
  avatarUrl
`;

/**
 * Fragment for user with profiles
 */
export const UserWithProfilesFragment = /* GraphQL */ `
  profiles {
    ${ProfileFragment}
  }
`;

/**
 * Fragment for base notification fields
 */
export const BaseNotificationFragment = /* GraphQL */ `
  id
  type
  createdAt
  seen
  read
  source
`;

/**
 * Fragment for Cyclone community fields
 */
export const CycloneCommunityFragment = /* GraphQL */ `
  id
  name
  logo
`;

/**
 * Fragment for Cyclone reply fields
 */
export const CycloneReplyFragment = /* GraphQL */ `
  id
  shortId
  snippet
  url
`;

/**
 * Fragment for Cyclone fan post fields
 */
export const CycloneFanPostFragment = /* GraphQL */ `
  id
  shortId
  title
  snippet
  url
`;

/**
 * Fragment for Cyclone ExternalRoot fields
 */
export const CycloneExternalRootFragment = /* GraphQL */ `
  id
  shortId
  friendlyId
  urls
`;

/**
 * Fragment for Coral reply fields
 */
export const CoralReplyFragment = /* GraphQL */ `
  id
  snippet
  url
`;

/**
 * Fragment for Coral comment fields
 */
export const CoralCommentFragment = /* GraphQL */ `
  id
  storyId
  snippet
  url
`;

/**
 * Fragment for Coral site fields
 */
export const CoralSiteFragment = /* GraphQL */ `
  id
  name
`;

/**
 * Fragment for Coral story fields
 */
export const CoralStoryFragment = /* GraphQL */ `
  id
  title
  url
`;
